(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cacb-product-inquiry"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cacb-inquiry]').forEach((root) => {
    if (root.dataset.inquiryReady) return;
    root.dataset.inquiryReady = 'true';
    const form = root.querySelector('form');
    const details = root.querySelector('details');
    const variants = JSON.parse(root.querySelector('[data-inquiry-variants]').textContent);
    const section = root.closest('.shopify-section');
    const syncVariant = () => {
      const variantInput = section && section.querySelector('form[action*="/cart/add"] [name="id"]');
      const selected = variants.find((variant) => String(variant.id) === String(variantInput && variantInput.value));
      if (!selected) return;
      const urlInput = root.querySelector('[data-inquiry-url]');
      if (!urlInput) return;
      const url = new URL(urlInput.value);
      url.searchParams.set('variant', selected.id);
      urlInput.value = url.href;
      root.querySelector('[data-inquiry-variant]').value = `${selected.title} (${selected.id})`;
      root.querySelector('[data-inquiry-sku]').value = selected.sku || '';
    };
    details.addEventListener('toggle', syncVariant);
    if (section) section.addEventListener('on:variant:change', syncVariant);
    form.addEventListener('submit', (event) => {
      syncVariant();
      const trap = root.querySelector('[data-inquiry-trap]');
      if (trap && trap.value) {
        event.preventDefault();
        root.querySelector('[data-inquiry-error]').hidden = false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
